import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { User } from '../models/user';

@Injectable()
export class LoginService {

  login(login: string, password: string, database?: string): Observable<User> {
    return of(null);
  }

  logout(): Observable<any> {
    return of(null);
  }

  get loggedInUser(): Observable<User> {
    return of(null);
  }

  resetPassword(email: string): Observable<string> {
    return of(null);
  }

  resetPasswordByToken(token: string, password: string, confirmPassword: string): Observable<string> {
    return of(null);
  }

  changePassword(password: string, newPassword): Observable<boolean> {
    return of(null);
  }
}
